import { isNotUndefined } from "@/shared/FunctionCore";

export const startAfterAPIresponse = () => {
    
  const toggleOverviewElements = (element1: Element | undefined, element2: Element | undefined, element3: Element | undefined) => {
    if (isNotUndefined(element1)) {
        element1.classList.toggle("overview-view-hide");
    }

    if (isNotUndefined(element2)) {
        element2.classList.toggle("overview-view-hide");
    }

    if (isNotUndefined(element3)) {
        element3.classList.toggle("overview-view-hide");
    }
};

const overviewIndustriesViewMore = window.document.querySelector(".overview-industries-view-more") ?? void 0;
const overviewIndustriesViewLess = window.document.querySelector(".overview-industries-view-less") ?? void 0;
const overviewViewMoreIndustriesList = window.document.querySelector(".overview-view-more-industries-list") ?? void 0;

if (isNotUndefined(overviewIndustriesViewMore)) {
    overviewIndustriesViewMore.addEventListener("click", () => {
        toggleOverviewElements(overviewIndustriesViewMore, overviewIndustriesViewLess ?? void 0, overviewViewMoreIndustriesList ?? void 0);
    });
}

if (isNotUndefined(overviewIndustriesViewLess)) {
    overviewIndustriesViewLess.addEventListener("click", () => {
        toggleOverviewElements(overviewIndustriesViewMore ?? void 0, overviewIndustriesViewLess, overviewViewMoreIndustriesList ?? void 0);
    });
}

const overviewOtherIndustriesViewMore = window.document.querySelector(".overview-other-industries-view-more") ?? void 0;
const overviewOtherIndustriesViewLess = window.document.querySelector(".overview-other-industries-view-less") ?? void 0;
const overviewViewMoreOtherIndustriesList = window.document.querySelector(".overview-view-more-other-industries-list") ?? void 0;

if (isNotUndefined(overviewOtherIndustriesViewMore)) {
    overviewOtherIndustriesViewMore.addEventListener("click", () => {
        toggleOverviewElements(overviewOtherIndustriesViewMore, overviewOtherIndustriesViewLess ?? void 0, overviewViewMoreOtherIndustriesList ?? void 0);
    });
}

if (isNotUndefined(overviewOtherIndustriesViewLess)) {
    overviewOtherIndustriesViewLess.addEventListener("click", () => {
        toggleOverviewElements(overviewOtherIndustriesViewMore, overviewOtherIndustriesViewLess, overviewViewMoreOtherIndustriesList);
    });
}

const overviewDescriptionReadMore = window.document.querySelector(".overview-description-read-more") ?? void 0;
const overviewDescriptionReadLess = window.document.querySelector(".overview-description-read-less") ?? void 0;

if (isNotUndefined(overviewDescriptionReadMore)) {
    overviewDescriptionReadMore.addEventListener("click", () => {
        toggleOverviewElements(overviewDescriptionReadMore, overviewDescriptionReadLess ?? void 0, void 0);
    });
}

if (isNotUndefined(overviewDescriptionReadLess)) {
    overviewDescriptionReadLess.addEventListener("click", () => {
        toggleOverviewElements(overviewDescriptionReadMore ?? void 0, overviewDescriptionReadLess, void 0);
    });
}

for (const element of [overviewIndustriesViewMore, overviewIndustriesViewLess, overviewOtherIndustriesViewMore, overviewOtherIndustriesViewLess, overviewDescriptionReadMore, overviewDescriptionReadLess]) {
    if (isNotUndefined(element)) {
        $(element).css("cursor", "pointer");
    }
}
  }